import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, LabelList, Cell } from 'recharts';
import { ChartTooltip } from './ChartTooltip';

// Premium histogram (BarChart) with the value printed in small text on top of
// each bar. Labels are only rendered when the series is sparse enough to stay
// readable (`showLabels`); otherwise the tooltip carries the value.
// The most recent bucket is highlighted to draw the eye to the current period.
export const LabeledBars = ({
  data = [],
  dataKey = 'value',
  name,
  color = 'var(--tenant-accent-500)',
  softColor = 'var(--tenant-accent-100)',
  height = 320,
  xKey = 'period',
  xTickFormatter,
  formatY,
  formatTip,
  formatLabel,
  showLabels = true,
  highlightLast = true,
}) => {
  const lastIdx = data.length - 1;
  return (
    <div style={{ height }}>
      <ResponsiveContainer width="100%" height="100%" minWidth={0}>
        <BarChart data={data} margin={{ top: 24, right: 8, bottom: 6, left: -6 }} barCategoryGap="18%">
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(11,19,32,0.06)" vertical={false} />
          <XAxis
            dataKey={xKey}
            tickLine={false}
            axisLine={false}
            tickFormatter={xTickFormatter}
            interval="preserveStartEnd"
            minTickGap={14}
            height={40}
            tick={{ fontSize: 11, fill: 'hsl(var(--muted-foreground))' }}
          />
          <YAxis
            tickLine={false}
            axisLine={false}
            width={46}
            tickFormatter={formatY}
            tick={{ fontSize: 11, fill: 'hsl(var(--muted-foreground))' }}
          />
          <Tooltip cursor={{ fill: 'rgba(11,19,32,0.04)' }} content={<ChartTooltip formatter={formatTip} />} />
          <Bar dataKey={dataKey} name={name} radius={[6, 6, 0, 0]} maxBarSize={46}>
            {data.map((entry, i) => (
              <Cell
                key={i}
                fill={highlightLast && i === lastIdx ? color : color}
                fillOpacity={highlightLast && i !== lastIdx ? 0.62 : 1}
              />
            ))}
            {showLabels && (
              <LabelList
                dataKey={dataKey}
                position="top"
                formatter={formatLabel}
                style={{ fontSize: 10, fontWeight: 600, fill: 'hsl(var(--foreground))' }}
              />
            )}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
